import { EmbedContainer } from './Container';
import { LiveboardEmbed } from '@thoughtspot/visual-embed-sdk/react';
import { NoObjectSelected } from './NoObjectSelected';
import { useVariable } from 'context/ThemeContext';
import { useEffect, useState } from 'react';
import { LIVEBOARD_FEATURE_FLAGS } from '../../constants';

const LiveboardEmbedBase = ({ embedRef, variables, embedSelections, setEmbedSelections }: any) => {
  const liveboardId = embedSelections?.pinboard;
  const [showNoObjectSelected, setShowNoObjectSelected] = useState(false);
  const {
    state: { liveboardList },
  } = useVariable();
  const [idToRender, setIdToRender] = useState(null);

  useEffect(() => {
    if (!liveboardId && liveboardList?.length > 0) {
      const defaultLiveboardId = liveboardList?.length > 0 ? liveboardList[0]?.id : null;

      if (defaultLiveboardId && setEmbedSelections) {
        setEmbedSelections((prev) => {
          const newSelections = { ...prev, pinboard: defaultLiveboardId };
          return newSelections;
        });
      }
    }
  }, [liveboardId, liveboardList, setEmbedSelections, embedSelections]);

  const effectiveLiveboardId =
    liveboardId || (liveboardList?.length > 0 ? liveboardList[0]?.id : null);

  useEffect(() => {
    setIdToRender(effectiveLiveboardId);
  }, [effectiveLiveboardId]);

  useEffect(() => {
    if (!idToRender) {
      const timer = setTimeout(() => {
        setShowNoObjectSelected(true);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [idToRender]);

  return idToRender ? (
    <LiveboardEmbed
      key={idToRender} // Force re-render when ID changes
      frameParams={{
        height: '100%',
      }}
      ref={embedRef}
      showLiveboardDescription
      showLiveboardTitle
      className="embed-content"
      disabledActionReason="Liveboard Embed"
      liveboardId={idToRender}
      {...LIVEBOARD_FEATURE_FLAGS}
      customizations={{
        style: {
          customCSS: {
            variables: variables,
          },
        },
      }}
    />
  ) : showNoObjectSelected ? (
    <NoObjectSelected title="No Liveboard selected" description="Select a Liveboard to see it" />
  ) : null;
};

export const LiveboardEmbedPage = (props) => {
  return <EmbedContainer EmbedComponent={LiveboardEmbedBase} {...props} />;
};
